import { useMemo, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useQR } from '../../utils/hooks/useQR';
import { motion, AnimatePresence } from 'motion/react';
import { transition, variants } from './variants';
import { useAuth } from '../../utils/Auth';
import QrInformation from '../../components/QrComponents/QrInformation';
import { useBack } from '../../utils/hooks/useBack';
import styles from './QrDetails.module.css';

export default function QrDetails(props) {

    const { reference } = props;
    const { qr_data, activeOrgId } = useAuth();
    const navigate = useNavigate();
    const nickname = useMemo(() => qr_data?.data?.nickname || '', [qr_data?.data?.nickname]);
    const params = useParams();
    useQR(reference, params?.id || '');

    const goBack = useBack();

    useEffect(() => {
        if (!qr_data?.data?.org_id || !activeOrgId) return;
        if (qr_data.data.org_id !== activeOrgId) {
            navigate('/organizations', { replace: true });
        }
    }, [qr_data?.data?.org_id, activeOrgId, navigate]);

    return (
        <div className={styles.wrapper}>
            <div className={styles.container}>
                <AnimatePresence mode='wait'>
                    <motion.div
                        key='details'
                        className={styles.details}
                        transition={{
                            ...transition, 
                            duration: .5,
                        }}
                        variants={variants}
                        initial='initial'
                        animate='animate'
                        exit='initial'
                    >
                        <div className={styles.header}>
                            <button className={styles.backBtn} onClick={goBack} style={window.location.pathname.includes('setup') ? {display: 'none'} : null}><i className='fas fa-arrow-left' style={{pointerEvents: 'none'}} />Back</button>
                            <h4 className={styles.nickname}>{nickname}</h4>
                            <div className={styles.qrId}>ID: <span>{qr_data?.id}</span></div>
                        </div>
                        <div className={styles.detailsInner}>
                            <AnimatePresence mode='wait'>
                                <motion.div
                                    key='configure'
                                    className={styles.motionWrap}
                                    transition={transition}
                                    variants={variants}
                                    initial='initial'
                                    animate='animate'
                                    exit='initial'
                                >
                                    <QrInformation />
                                </motion.div>
                            </AnimatePresence>
                        </div>
                    </motion.div>
                </AnimatePresence>
            </div>
        </div>
    );
};
